import { Switch, Tooltip, Typography } from '@cobliteam/ui/components';

const NoAccessHover = () => {
  return (
    <Tooltip
      content='Você não tem permissão para ver
      locais. Peça acesso ao administrador.'
    >
      <div className='mt-2.5 flex h-full items-center gap-2.5'>
        <Switch disabled />
        <Typography variant='caption-bold' color='secondary'>
          Locais de interesse
        </Typography>
      </div>
    </Tooltip>
  );
};

export default NoAccessHover;
